import {Injector, LOCALE_ID} from '@angular/core';
import { TranslateService} from '@ngx-translate/core';
import {LocalStorageKey} from '@common-module/app-enums/local-storage-key';
import {EnvironmentHelper} from '@common-module/services/environment-helper';

export function initTranslationService(translate: TranslateService, injector: Injector) {
  return async () => {
    await injector.get<any>(LOCALE_ID, Promise.resolve(null));

    let userLang = window.localStorage.getItem(LocalStorageKey.LANGUAGE);
    userLang = userLang ? userLang : injector.get(EnvironmentHelper).defaultLanguage;
    // en — резервный язык: ключ, ещё не долетевший до текущей локали через
    // Crowdin, берётся из en.json (с интерполяцией параметров) вместо показа
    // сырого ключа. Fallback ngx-translate работает только при
    // defaultLang !== currentLang.
    translate.setDefaultLang('en');
    try {
      await translate.use(userLang).toPromise();
    } catch (err) {
      console.log(err);
    }
  };
}
